module.exports = __webpack_public_path__ + "img/GAME_GOSTOP1.9a5eb5a1.jpg";